<template>
  <div class="beikostworkshop">
    <h1>Beikostworkshop in Koblenz & Online</h1>
    <div class="next-event-bubble-wrap-zone">
      <p>Der Beginn der Beikost ist ein spannender Meilenstein in der Entwicklung eures Kindes – und oft mit vielen Fragen verbunden:</p>
    </div>
    <ul>
      <li>Wann ist mein Baby bereit für Beikost?</li>
      <li>Brei oder Baby led weaning – was passt zu uns?</li>
      <li>Was darf mein Baby essen (und was nicht)?</li>
      <li>Verschlucken: Wie kann ich mein Baby schützen?</li>
      <li>Wie sind die Empfehlungen zur Allergieprävention?</li>
      <li>Ab wann darf mein Baby Wasser trinken?</li>
      <li>Was tun, wenn mein Baby nichts essen will?</li>
    </ul>
    <p>In diesem Workshop gehen wir auf all diese Fragen ein und besprechen praxisnah, wie ihr euren Beikoststart entspannt und selbstbewusst gestalten könnt – 
    <strong>ganz ohne Druck und mit viel Freude am gemeinsamen Essen.</strong></p>
    <p>Am Ende bleibt selbstverständlich Zeit für eure individuellen Fragen. Bitte habt jedoch Verständnis, dass eine ausführliche <router-link to="/beikostberatung/">Einzelberatung</router-link> in diesem Rahmen nicht möglich ist.</p>
    <NextEventBubble />
    <p>
      Ihr seid mindestens zu viert und möchtet einen <strong>privaten Kurs für eure Gruppe</strong>? Vielleicht sogar ganz bequem bei euch zu Hause? Kein Problem – wir finden einen Termin und ich komme gerne vorbei!
    </p>
  </div>
</template>

<script>
import NextEventBubble from "@/components/NextEventBubble.vue";

export default {
  name: 'Beikostworkshop',
  components: {
    NextEventBubble
  }
}
</script>

<style scoped>
.beikostworkshop {
}
@media (min-width: 70rem) {
  .next-event-bubble-wrap-zone {
    padding-right: clamp(0rem, 50rem + -50vw, 15rem);
  }
}
</style>